// Предустановленный список
import autoText from './components/custom';

export const AT_TYPE = 'custom';

export default autoText;
